import './styles';
import 'angular-cookie/angular-cookie.js';
import {
  default as PaymentModal,
  template
} from './paymentModal';
import {
  default as AlertModal,
  template as alertTemplate
} from './alertModal';

import moment from 'moment';
import confirmation from 'ngtemplate-loader!./confirmation.tpl.html';
import thanks from 'ngtemplate-loader!./thanks.tpl.html';
import form from 'ngtemplate-loader!./form.tpl.html';

import { Gift } from './index';

export const moduleName = 'rezflow.giftForm'
export const name = 'giftForm';

const today = moment.utc(new Date()).add(1, 'day');

export class GiftForm {

  /* @ngInject */
  constructor($scope, $filter, GiftAPI, $state, $rootScope, isPublic, $location, $modal) {
    const vm = this;
    this.$scope = $scope;
    this.$filter = $filter;
    this.api = GiftAPI;
    this.$state = $state;
    this.$location = $location;
    this.user = $rootScope.user;
    this.isPublic = isPublic;
    this.company = this.user ? this.user.activeCompany : undefined;
    this.chargeOpts = {
      amount: true
    }
    this.confirmation = confirmation;
    this.thanks = thanks;
    this.showConf = false;
    this._previousType = this.type;
    this._modal = $modal;
    this.modal = undefined;
  }

  get discountTotal() {
    const amount = this.gift.amount;
    const discount = this.gift.discount || '0';
    const matched = discount.match(/^(\$)?((\d+)\.?(\d+)?)(\%)?$/);
    const isPercent = matched && matched[3] !== undefined || false;
    let discountValue = parseFloat(matched && matched[2] || 0);
    if (isPercent) discountValue = (amount) / (100 / discountValue);
    return discountValue;
  }

  get payments() {
    const payments = this.gift.cards.filter((card) => card.charges.length).filter((card) => card.charges.length).reduce((prevCard, card) => {
      const charges = card.charges.reduce((prevCharge, charge) => {
        return charge.amount + prevCharge;
      }, 0);
      return prevCard + charges;
    }, 0);
    const discount = this.discountTotal;
    return (payments || 0) + discount;
  }

  balanceDue() {
    if (this.type === 'certificate' && !this.payments) return 0;
    if (this.type === 'donation' || this.type === 'promo') return false;
    return (this.gift.amount - this.gift.payments) || 0;
  }

  checkValidation(form) {
    console.log(form);
  }

  openAlertModal() {
    this.modal = this._modal.open({
      templateUrl: alertTemplate,
      controller: AlertModal,
      controllerAs: '$ctrl',
      resolve: {
        gift: () => {
          return this.gift;
        },
        formClass: () => this
      }
    });

    this.modal.result.then(({
      active,
      gift
    }) => {
      switch (active) {
        case 'discount':
          this.discount = gift.discount;
          break;
        default:
          break;
      }
    }).catch(console.warn);

  }

  openPaymentModal() {
    this.modal = this._modal.open({
      templateUrl: template,
      controller: PaymentModal,
      controllerAs: '$ctrl',
      resolve: {
        gift: () => {
          return this.gift;
        },
        formClass: () => this
      }
    });

    this.modal.result.then(({active, gift}) => {
      switch (active) {
        case 'discount':
          this.discount = gift.discount;
          break;
        default:
          break;
      }
    }).catch(console.warn);

  }

  preSave() {
    this.working = true;
    this.sendTo = 'recipient';
    switch (this.gift.shipping) {
      case 'print':
      case 'email':
        console.log(this.gift.type);
        this.isElectronic = true;
        console.log(this.gift.type)
        if (this.gift.shipping === 'print') {
          this.gift.meta.print = true;
          this.gift.send_on = this.today;
          this.gift.contact.recipient.email = this.purchaser.email;
        }
        this.confType = this.gift.shipping;
        this.gift.shipping = 0;
        break;
      default:
        break;
    }
  }

  save(redir = false) {

    
    function phoneToNumber(phone) {
      return phone ? phone.toString().replace(/[^0-9\.]+/g, '') : phone;
    }
    this.preSave();
    this.gift.contact.purchaser.phone = phoneToNumber(this.gift.contact.purchaser.phone);
    this.gift.contact.recipient.phone = phoneToNumber(this.gift.contact.recipient.phone);
    this.gift.used = (this.gift.used || []).filter(used => used.amount);

    const req = this.api.req(this.isPublic ? this.company._id : undefined);

    const saveIt = () => {

      if (this.isPublic) {
        this.gift.stripeToken = this.gift.cards[0].token;
        this.gift.cards = [];
      }

      const Gift = new req(this.gift);
      const saveFn = () => this.isNew ? Gift.$save() : Gift.$update();

      // if (this.charged) {
        saveFn().then((resp) => {
          const res = this.isPublic ? resp : resp.results;
          if (res.id) {
            this.gift._id = res.id;
            this.gift.created = res.created;
            this.working = false;
          }
          if (!res.error) {
            this.gift.shipping = this.shippingVal();
            this.postSave(redir, res);
          }
        }).catch(e => {
          this.working = false;
          console.error(e);
        });
      // }
    }

    if (!this.gift.customerId && (this.type !== 'promo' || this.type !== 'donation') && this.balance > 0) {
      if (!this.isPublic) {
        const doubleCheck = confirm(`No customer ID was stored. If cards are associated with this gift then you should verify in stripe to ensure no data is lost. Proceed with save?`);
        if (doubleCheck) saveIt();
      } else {
        saveIt();
      }
    } else {
      saveIt();
    }

  }

  codeEntry(e) {
    if(!this.isPublic) {
      const isPromo = e.target.value.length === 1 && e.target.value[0].match(/^p/i) !== null;
      const isDonation = e.target.value.length === 1 && e.target.value[0].match(/^d/i) !== null;

      if(isDonation || isPromo) {
        this.lockCodeEntry = true;
        switch (true) {
          case isPromo:
            this.promoCode()
            break;
          case isDonation:
            this.donationCode()
            break;
        }
      }
    }
  }

  set discount(discount) {
    this.gift.discount = discount;
  }

  get discount() {
    return this.gift.discount;
  }

  set shippingFee(fee) {
    if (this.gift.electronic) return 0;
    this.gift.shipping = fee;
  }

  get shippingFee() {
    if (this.gift.electronic || this.gift.shipping === 'print' || this.gift.shipping === 'email') return 0;
    return parseFloat(this.gift.shipping);
  }

  eCode() {
    const API = this.api.req();
    const token = API.token().$promise;
    return token.then((tok) => {
      // if(!this.gift.code) // This was intentional and a previous requirement, but gabe thinks its a bug now.
      this.gift.code = tok.code;
    });

  }

  promoCode() {
    const API = this.api.req();
    const token = API.promo().$promise;
    return token.then((tok) => {
      this.gift.code = tok.next_code;
      this.lockCodeEntry = false;
    });
  }

  donationCode() {
    const API = this.api.req();
    const token = API.donation().$promise;
    return token.then((tok) => {
      this.gift.code = tok.next_code;
      this.lockCodeEntry = false;
    });
  }

  get amount() {
    return this._amount;
  }

  set amount(amount) {
    this._amount = amount;
    this.gift.amount = amount;
  }

  get charged() {
    return this.gift.cards.map(card => {
      return card.charges.map(charge => {
        const amount = charge.amount;
        const refunds = charge.refunds.map(refund => refund.amount).reduce((prev, cur) => prev + cur, 0);
        return amount - refunds;
      }).reduce((prev, cur) => prev + cur, 0)
    }).reduce((prev, cur) => prev + cur, 0)
  }

  get discountTotal() {
    const amount = this.subtotal;
    const discount = this.discount || '0';
    const matched = discount.match(/^(\$)?((\d+)\.?(\d+)?)(\%)?$/);
    const isPercent = matched[5] !== undefined;
    let discountValue = parseFloat(matched[2]);
    if (isPercent) discountValue = (amount) / (100 / discountValue);
    return discountValue;
  }

  get balance() {
    const total = this.total || 0;
    return (total - (this.charged || 0));
  }

  get redeemed() {
    return this.gift.booking;
  }

  get used() {
    return (this.gift.used || []).reduce((p, c) => {
      if(!c.amount) c.amount = 0;
      return p + c.amount;
    }, 0)
  }

  get cardBalance() {
    return this.redeemed ? 0 : this.amount - this.used;
  }

  get total() {
    const amount = this.amount;
    const shipping = this.shippingFee;
    const discountValue = this.discountTotal;
    return (amount + shipping) - discountValue;
  }

  get subtotal() {
    const amount = this.amount;
    const shipping = Number.parseFloat(this.shippingFee, 10);
    return (amount + shipping);
  }

  get isNew() {
    return this.gift._id === undefined;
  }

  get today() {
    return today;
  }

  set sendTo(person) {
    if (person === 'recipient') {
      this.gift.contact.recipient.send_to = true;
      this.gift.contact.purchaser.send_to = false;
    }
    if (person === 'purchaser') {
      this.gift.contact.purchaser.send_to = true;
      this.gift.contact.recipient.send_to = false;
    }
  }

  get sendTo() {
    const purchaser = this.gift.contact.purchaser.send_to && 'purchaser';
    const recipient = this.gift.contact.recipient.send_to && 'recipient';
    return purchaser || recipient;
  }

  get toRecipient() {
    return this.sendTo === 'recipient';
  }

  get toPurchaser() {
    return this.sendTo === 'purchaser';
  }

  get purchaser() {
    return this.gift.contact.purchaser;
  }

  get recipient() {
    return this.gift.contact.recipient;
  }

  get pageHeader() {
    let header = `New Gift Purchase`
    if (!this.gift._id) {
      switch (this.type) {
        case 'promo':
          header = `Creating New Promotion`;
          break;
        case 'donation':
          header = `Creating New Donation`;
          break;
      }
    }
    let toPurchaser = !this.isNew && this.gift.contact.purchaser.send_to;
    let toRecipient = !this.isNew && this.gift.contact.recipient.send_to;
    switch (true) {
      case toPurchaser:
        header = `Gift purchased by ${this.gift.contact.purchaser.name}`;
        break;
      case toRecipient:
        header = `Gift purchased for ${this.gift.contact.recipient.name}`;
        break;
      default:
        break;
    }
    return header;
  }

  get prices() {
    return this.company.prepaids.prices;
  }

  set isElectronic(bool) {
    if (typeof bool !== 'boolean') throw new TypeError('isElectronic only accepts boolean values');
    this.gift.electronic = bool;
    switch (this.gift.type) {
      case 'donation':
      case 'promo':
        this.gift.type = this.gift.type;
        break;
      default:
        this.gift.type = bool ? 'electronic' : 'card';
        break;
    }
  }

  get isElectronic() {
    return this.gift.electronic;
  }

  get initialGift() {
    const meta = this.gift.meta || {};
    return {
      electronic: true,
      type: this.gift.type || 'electronic',
      cards: [],
      meta: Object.assign({}, {
        online: false
      }, meta),
      contact: {
        purchaser: {
          send_to: false
        },
        recipient: {
          send_to: true
        }
      }
    }
  }

  get typeLabel() {
    switch (this.type) {
      case 'gift':
        return 'Purchase';
      case 'promo':
        return 'Promotion';
      default:
        return this.type.charAt(0).toUpperCase() + this.type.slice(1)
    }
  }

  sentDate() {
    if (!this.isPrint && this.gift.electronic) {
      const sendOn = moment.utc(this.gift.send_on);
      return sendOn.isAfter(moment()) ? false : sendOn;
    }
    return moment.utc(this.gift.created);
  }

  get isPrint() {
    return this.gift.meta && this.gift.meta.print || false;
  }

  get isPromo() {
    return this.type === 'promo';
  }

  get isDonation() {
    return this.type === 'donation';
  }

  postSave(redir, gift) {
    if (redir) this.$state.go('listPrepayments', { type: this.type, page: 1 });
  }

  addUsed(amount) {
    const alreadyUsed = this.gift.used.reduce((prev, cur) => prev + cur.amount, 0);
    if (this.gift.amount >= (alreadyUsed + amount)) {
      this.gift.used.push({
        date: moment.utc(),
        amount: amount,
        user: this.user._id
      });
  
      this.save(false);
    } else {
      alert('You\'re trying to redeem too much')
    }
  }

  shippingVal() {
    const shippingType = this.gift.meta && !this.gift.meta.print ? 'email' : 'print';
    return this.gift.shipping && this.gift.shipping !== 0 ? this.gift.shipping : shippingType;
  }

  printAndClose() {
    window.open(`/p/gift/${this.gift._id}/print?id=${this.gift.company}`, '_blank');
    this.$state.go('listPrepayments', {
      type: this.type,
      page: 1
    });
  }

  setType() {
    switch (this.gift.type) {
      case 'electronic':
        return 'card';
      default:
        return this.gift.type;
    }
  }

  $onInit() {

    this.init();

    const _gift = Object.assign({}, this.initialGift, this.gift, {
      shipping: this.shippingVal(),
    });
    
    this.gift = new Gift(_gift, this.api);
    
    this.type = this.setType();
    
    this._previousType = this.type;
    
    this.booking = this.gift.booking;
    
    this.sentOn = this.sentDate() || undefined;
    this.amount = this.gift.amount;
  }

  $doCheck() {
    if (this._previousType !== this.type) {
      this._previousType = this.type;
      this._previousCode = this.gift.code;
      // type changed
      switch (this.type) {
        case 'gift':
          this.eCode();
          break;
        case 'promo':
          this.promoCode();
          break;
        case 'donation':
          this.donationCode();
          break;
      }
    }
  }

  expiresJump(years) {
    this.gift.expiration = moment.utc(today).add(years, 'year');
    this.noExpiration = false;
  }

  $onChanges(changed) {
  }

  init() {
    if (!this.gift._id) {
      switch (this.type || this.gift.type) {
        case 'promo':
          this.promoCode();
          break;
        case 'donation':
          this.donationCode();
          break;
        default:
          this.gift.type = 'gift';
      }
    }
  }

}

export default (MODULE) => {

  angular.module(MODULE)
    .constant('isPublic', false)
    .component(name, {
      bindings: {
        gift: '=',
        company: '<'
      },
      templateUrl: form,
      controller: GiftForm
    });

  return name;

};



// WEBPACK FOOTER //
// ./client/assets/scripts/modules/gifts/form.js